import React, { useEffect, useState } from 'react'

import CookiesContext from 'contexts/CookiesContext'

import * as service from 'service'

const CookiesProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [authenticating, setAuthenticating] = useState(false)

  useEffect(() => {
    const authenticate = async () => {
      try {
        setAuthenticating(true)
        await service.dponet.auth.authenticateCookie()
      } catch {
        // Silêncio proposital: quem consome a sessão de cookies trata a falha
        // pelo erro da própria requisição, e travar aqui deixaria o app preso.
      } finally {
        setAuthenticating(false)
        setLoading(false)
      }
    }

    if (!service.cookies.auth.isAuthenticated()) {
      authenticate()
    }
    //eslint-disable-next-line
  }, [])

  return (
    <CookiesContext.Provider
      value={{
        authenticating,
        loading,
        setLoading,
      }}
    >
      {children}
    </CookiesContext.Provider>
  )
}

export default CookiesProvider
